import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { type ComponentProps } from 'react';

import { Logo } from '../../Logo/Logo';
import { ReactComponent as LogoArrowValentines } from './LogoArrowValentines.svg';

export const ValentineLogo = observer(function ValentineLogo(props: ComponentProps<typeof Logo>) {
	return (
		<Tooltip
			{...{
				title: "Happy Valentine's Day!",
				placement: 'right',
				children: <Logo {...{ children: <LogoArrowValentines />, ...props }} />,
			}}
		/>
	);
});
